import React, { useCallback, useEffect, useState } from 'react';
import style from '../Styles/Reviews.module.css';
import { useNavigate } from 'react-router-dom';
import { Empty, Pagination } from 'antd';

import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Space } from 'antd';

import { getReviews, getLatestReviews, getOldestReviews, getReviewsLowerRated } from '../services/api.js';
import { Card, Masonry } from 'antd';
import { LoadingOutlined, StarFilled } from '@ant-design/icons';

const Reviews = () => {
  const navigate = useNavigate();
  const [reviewData, setReviewData] = useState([]);
  const [received, setReceived] = useState(false);
  
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedSort, setSelectedSort] = useState('1');
  const pageSize = 10;

  const handleNavigationToReviews = useCallback(() => {
    navigate('/reviews/write');
  }, [navigate]);

  const cameledCase = (str) => {
    if (!str) return '';
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        const result = await getReviews();
        setReviewData(result);
        setReceived(true);
      } catch (error) {
        setReceived(true);
        console.error('Error fetching reviews:', error);
      }
    };
    fetchReviews();
  }, []);

  const indexOfLastReview = currentPage * pageSize;
  const indexOfFirstReview = indexOfLastReview - pageSize;
  const currentReviews = reviewData.slice(indexOfFirstReview, indexOfLastReview);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const loadReviews = async (apiFn) => {
  setReceived(false);

  try {
    const result = await apiFn();
    setReviewData(result || []);
  } catch (error) {
    console.error(error);
    setReviewData([]);
  } finally {
    setReceived(true);
  }
};

const items = [
  {
    key: '1',
    label: 'Highest Rated',
    onClick: () => {
        if (selectedSort === '1') return;
      setSelectedSort('1');
      loadReviews(getReviews);
    }
  },
  {
    key: '2',
    label: 'Lowest Rated',
    onClick: () => {
        if (selectedSort === '2') return;
      setSelectedSort('2');
      loadReviews(getReviewsLowerRated);
    }
  },
  {
    key: '3',
    label: 'Latest',
    onClick: () => {
        if (selectedSort === '3') return;
      setSelectedSort('3');
      loadReviews(getLatestReviews);
    }
  },
  {
    key: '4',
    label: 'Oldest',
    onClick: () => {
        if (selectedSort === '4') return;
      setSelectedSort('4');
      loadReviews(getOldestReviews);
    }
  }
];

  return (
    <div className={style.reviews}>
      <div className={style.reviewHeading}>
        <div className={style.quoteRow}>
          <div className={style.line}></div>
          <span className={style.quoteIcon}>“</span>
          <div className={style.line}></div>
        </div>
        <h1>What Our Customers Say</h1>
        <p>Experiences from real travelers who explored the world with us.</p>
        <div className={style.bottomAccent}></div>
      </div>

      <div className={style.sortingContainer} trigger={['click']}>
          <Dropdown menu={{ items }} trigger={['click']}>
            <button 
            type="button"
            onClick={(e) => e.preventDefault()}
            className={style.sortButton}
            >
            <Space>
                {items.find(item => item.key === selectedSort)?.label}
                <DownOutlined />
            </Space>
            </button>
        </Dropdown>
      </div>

      <div className={style.reviewContainer}>
        {received ? (
          reviewData.length === 0 ? (
            <Empty className={style.emptyState} description="No reviews yet. Be the first to write a review!" />
          ) : (
            <div className={style.masonryWrapper}>
              <Masonry
                columns={{ xs: 1, sm: 2, md: 3, lg: 4 }}
                gutter={{ xs: 12, sm: 16, md: 20 }}
                items={currentReviews.map((review) => ({
                  key: review.id,
                  children: (
                    <Card
                      hoverable
                      style={{ width: '100%', cursor: 'default' }}
                      title={cameledCase(review.client_name)}
                      extra={
                        <>
                          {review.rating}
                          <StarFilled style={{ color: '#edd227', fontSize: 'small', marginLeft: '0.3rem' }} />
                        </>
                      }
                    >
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                        <div>
                          <h3 style={{ margin: 0, fontSize: '0.8rem' }}>{cameledCase('Trip To')}</h3>
                        </div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                          {review.destination?.map((destination) => (
                            <div
                              key={destination}
                              style={{
                                background: '#f3f3f3',
                                padding: '0.35rem 0.8rem',
                                borderRadius: '999px',
                                fontSize: '0.85rem',
                              }}
                            >
                              {cameledCase(destination)}
                            </div>
                          ))}
                        </div>
                        <h3 style={{ margin: 0, fontSize: '0.8rem' }}>{cameledCase('Experience')}</h3>
                        <p style={{ margin: 0, lineHeight: 1.7 }}>{review.experience}</p>
                      </div>
                    </Card>
                  ),
                }))}
              />

              <div style={{ display: 'flex', justifyContent: 'center', marginTop: '2.5rem', marginBottom: '1.5rem' }}>
                <Pagination
                  current={currentPage}
                  pageSize={pageSize}
                  total={reviewData.length}
                  onChange={handlePageChange}
                  showSizeChanger={false} 
                />
              </div>
            </div>
          )
        ) : (
          <div className={style.loadingContainer}>
            <LoadingOutlined style={{ fontSize: 24, color: 'whitesmoke' }} spin />
          </div>
        )}
      </div>

      <div className={style.fixedButton}>
        <button className={style.buttonStyle} onClick={handleNavigationToReviews}>
          Write a Review
        </button>
      </div>
    </div>
  );
};

export default Reviews;
